// extracted by mini-css-extract-plugin
export default {"widget":"ThreeByOneWidget_widget__xvTar"};